(function () {
  class BundleProducts extends HTMLElement {
    constructor() {
      super();
      this.titleElement = this.querySelector('.l-title');
      this.bundleProducts = this.querySelectorAll('.l-bundle-product');
      this.selectedProduct = null;
      this.productData = {};
      this.form = document.getElementById('AddToCartForm--{{ unique }}');
      if (!this.form) this.form = document.querySelector('[data-product-form]');
      if (!this.form) this.form = document.querySelector('form[action*="/cart/add"]');
      this.currentBundleInput = null;
      this.priceElements = document.querySelectorAll('[data-product-price]');
      this.comparePriceElements = document.querySelectorAll('[data-compare-price]');
      console.log('Form element found:', !!this.form);
      if (document.readyState === 'complete') {
        this.initializePriceDisplay();
      } else {
        window.addEventListener('load', () => this.initializePriceDisplay());
      }
    }

    initializePriceDisplay() {
      const activeProduct = this.querySelector('.l-bundle-product.is-active');
      if (!activeProduct) return;
      this.selectedProduct = activeProduct;
      this.updatePriceDisplay();
      console.log('Initial price display updated for:', activeProduct.dataset.title || 'active product');
    }

    connectedCallback() {
      const onReady = () => this._initWhenReady();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', onReady, { once: true });
      } else {
        onReady();
      }
    }

    _initWhenReady() {
      let tries = 0;
      const tryInit = () => {
        this.form =
          this.form ||
          document.getElementById('AddToCartForm--{{ unique }}') ||
          document.querySelector('[data-product-form]') ||
          document.querySelector('form[action*="/cart/add"]');
        tries += 1;
        if (this.form || tries >= 10) {
          this.initialize();
          return;
        }
        setTimeout(tryInit, 200);
      };
      tryInit();
    }

    initialize() {
      if (!this.form) {
        this.form = document.getElementById('AddToCartForm--{{ unique }}');
        if (!this.form) this.form = document.querySelector('[data-product-form]');
        if (!this.form) this.form = document.querySelector('form[action*="/cart/add"]');
        console.log('Form found on initialize:', !!this.form, this.form?.id || 'No ID');
      }

      this.originalTitle = this.titleElement.textContent.trim();
      this.bundleProducts.forEach((product) => {
        product.addEventListener('click', this.handleProductSelect.bind(this));
        const handle = product.dataset.product;
        if (handle) this.fetchProductData(handle);
      });
      this.selectedProduct = this.querySelector('.l-bundle-product.is-active');
      if (this.form && this.selectedProduct) {
        if (!this.selectedProduct.hasAttribute('data-main')) {
          this.updateFormForBundleSelection(this.selectedProduct);
        }
        this.updatePriceDisplay();
      }
    }

    async fetchProductData(handle) {
      try {
        const data = await (await fetch(`/products/${handle}.js`)).json();
        this.productData[handle] = data;
      } catch (error) {
        console.error('Error fetching product data:', error);
      }
    }

    handleProductSelect(event) {
      const selectedProduct = event.currentTarget;
      const handle = selectedProduct.dataset.product;
      if (selectedProduct === this.selectedProduct) return;

      this.bundleProducts.forEach((product) => {
        product.classList.remove('is-active');
      });
      selectedProduct.classList.add('is-active');
      this.selectedProduct = selectedProduct;
      this.updateTitle();
      this.updatePriceDisplay();
      this.updateFormForBundleSelection(selectedProduct);

      let productCssClass = '';
      if (selectedProduct.classList.contains('bundle1')) {
        productCssClass = 'bundle1';
      } else if (selectedProduct.classList.contains('bundle2')) {
        productCssClass = 'bundle2';
      }

      const eventData = { element: productCssClass };
      const customEvent = new CustomEvent('bundle-selection:changed', {
        bubbles: true,
        detail: eventData,
      });
      this.dispatchEvent(customEvent);
      console.log('Bundle selection changed:', eventData);
    }

    updatePriceDisplay() {
      if (!this.selectedProduct) return;

      const currentPrice = this.selectedProduct.dataset.offerPrice;
      const originalPrice = this.selectedProduct.dataset.price;
      if (!currentPrice && !originalPrice) return;

      const displayPrice = currentPrice || originalPrice;
      const formattedCurrentPrice = this.formatMoney(displayPrice);
      const formattedOriginalPrice = originalPrice ? this.formatMoney(originalPrice) : '';
      const isOnSale =
        currentPrice && originalPrice && parseFloat(originalPrice) > parseFloat(currentPrice);

      console.log('Updating prices:', { formattedCurrentPrice, formattedOriginalPrice, isOnSale });

      const allPriceElements = document.querySelectorAll('[data-product-price]');
      const allComparePriceElements = document.querySelectorAll('[data-compare-price]');

      allPriceElements.forEach((element) => {
        element.innerHTML = formattedCurrentPrice;
        if (isOnSale) {
          element.classList.add('product__price--sale');
        } else {
          element.classList.remove('product__price--sale');
        }
      });

      allComparePriceElements.forEach((element) => {
        if (isOnSale) {
          element.innerHTML = formattedOriginalPrice;
          element.style.display = '';
          element.classList.remove('hidden');
        } else {
          element.innerHTML = '';
          element.style.display = 'none';
          element.classList.add('hidden');
        }
      });

      const priceOffElements = document.querySelectorAll('[data-price-off]');
      if (priceOffElements.length > 0 && isOnSale) {
        const discount = parseFloat(originalPrice) - parseFloat(currentPrice);
        const percentOff = Math.round((discount / parseFloat(originalPrice)) * 100);
        priceOffElements.forEach((element) => {
          element.classList.remove('hidden');
          const amountElement = element.querySelector('[data-price-off-amount]');
          if (amountElement) amountElement.textContent = `${this.formatMoney(Math.round(discount))} (${percentOff} %)`;
        });
      } else {
        priceOffElements.forEach((element) => {
          element.classList.add('hidden');
        });
      }

      document.querySelectorAll('[data-add-to-cart-text]').forEach((container) => {
        const priceInButton = container.querySelector('[data-product-price]');
        const comparePriceInButton = container.querySelector('[data-compare-price]');
        if (priceInButton) {
          priceInButton.innerHTML = formattedCurrentPrice;
          if (isOnSale) {
            priceInButton.classList.add('product__price--sale');
          } else {
            priceInButton.classList.remove('product__price--sale');
          }
        }
        if (comparePriceInButton) {
          if (isOnSale) {
            comparePriceInButton.innerHTML = formattedOriginalPrice;
            comparePriceInButton.style.display = '';
          } else {
            comparePriceInButton.innerHTML = '';
            comparePriceInButton.style.display = 'none';
          }
        }
      });
    }

    formatMoney(amount) {
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
      }).format(parseFloat(amount) / 100);
    }

    updateFormForBundleSelection(selectedProduct) {
      this.removeBundleInputs();
      if (selectedProduct.hasAttribute('data-main')) {
        console.log('Main product selected, removing bundle inputs');
        return;
      }

      const bundleHandle = selectedProduct.dataset.product;
      const variantOption = selectedProduct.dataset.variantOption;
      if (!bundleHandle) {
        console.error('No bundle handle found');
        return;
      }

      const bundleData = this.getBundleData(bundleHandle);
      if (!bundleData) {
        console.error('No bundle data found for handle:', bundleHandle);
        return;
      }

      const variantId = this.getVariantId(bundleData, variantOption);
      if (!variantId) {
        console.error('No variant ID found for option:', variantOption);
        return;
      }

      this.addBundleInput(variantId);
      console.log('Added bundle input for variant:', variantId);
    }

    getBundleData(handle) {
      if (this.productData[handle]) return this.productData[handle];
      if (handle === bundleProduct1.handle) return bundleProduct1;
      if (handle === bundleProduct2.handle) return bundleProduct2;
      if (handle === mainProduct.handle) return mainProduct;
      return null;
    }

    getVariantId(productData, variantOption) {
      console.log('Finding variant by position:', variantOption);
      if (!productData || !productData.variants || !productData.variants.length) {
        console.error('Invalid product data:', productData);
        return null;
      }

      const numericPosition = parseInt(variantOption);
      if (!isNaN(numericPosition) && numericPosition > 0 && numericPosition <= productData.variants.length) {
        const variantIndex = numericPosition - 1;
        const variant = productData.variants[variantIndex];
        console.log(`Selected variant at position ${numericPosition}:`, variant.id);
        return variant.id;
      }

      if (variantOption !== 'first') {
        console.warn(`No variant match for "${variantOption}", using first variant`);
      }
      return productData.variants[0].id;
    }

    addBundleInput(variantId) {
      if (!this.form) {
        console.error('Form element not found');
        return;
      }

      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'items[0][id]';
      input.value = variantId;
      input.className = 'bundle-product-input';

      const qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = 'items[0][quantity]';
      qtyInput.value = '1';
      qtyInput.className = 'bundle-product-input';

      this.form.appendChild(input);
      this.form.appendChild(qtyInput);
      this.currentBundleInput = [input, qtyInput];
    }

    removeBundleInputs() {
      if (!this.form) {
        console.error('Form element not found');
        return;
      }

      this.form.querySelectorAll('.bundle-product-input').forEach((input) => {
        console.log('Removing input:', input);
        input.remove();
      });
      this.currentBundleInput = null;
    }

    updateTitle() {
      if (this.selectedProduct.hasAttribute('data-main')) {
        this.titleElement.textContent = this.originalTitle;
        return;
      }

      const dataTitle = this.selectedProduct.dataset.title;
      if (dataTitle) {
        this.titleElement.textContent = dataTitle;
        return;
      }

      const handle = this.selectedProduct.dataset.product;
      if (this.productData[handle]) {
        this.titleElement.textContent = this.productData[handle].title;
      } else {
        this.fetchProductData(handle).then(() => {
          if (this.productData[handle]) {
            this.titleElement.textContent = this.productData[handle].title;
          }
        });
      }
    }
  }

  customElements.define('bundle-products', BundleProducts);

  class ProductAccordion extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('[data-collapsible-trigger]');
      this.container = this.querySelector('[data-collapsible-container]');
      this.content = this.querySelector('[data-collapsible-content]');
      this.isPageTemplate = document.body.classList.contains('template-page');
    }

    connectedCallback() {
      if (!this.isPageTemplate || !this.button) return;
      this.button.addEventListener('click', this.handleClick.bind(this));
      this.container.style.transition = 'height 0.3s ease';
      this.container.style.overflow = 'hidden';
      if (!this.button.classList.contains('is-expanded')) {
        this.container.style.height = '0';
      }
    }

    handleClick(e) {
      e.preventDefault();
      const isExpanded = this.button.classList.contains('is-expanded');
      this.button.classList.toggle('is-expanded');
      this.container.classList.toggle('is-expanded');
      this.button.setAttribute('aria-expanded', !isExpanded);

      if (isExpanded) {
        const contentHeight = this.content.scrollHeight;
        this.container.style.height = contentHeight + 'px';
        this.container.offsetHeight;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.container.style.height = '0';
          });
        });
      } else {
        const contentHeight = this.content.scrollHeight;
        this.container.style.height = contentHeight + 'px';
        setTimeout(() => {
          if (this.button.classList.contains('is-expanded')) {
            this.container.style.height = 'auto';
          }
        }, 300);
      }
    }

    disconnectedCallback() {
      if (this.button) {
        this.button.removeEventListener('click', this.handleClick.bind(this));
      }
    }
  }

  customElements.define('product-accordion', ProductAccordion);

  class CustomVariantSelector extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.handleVariantChange.bind(this));
    }

    handleVariantChange(event) {
      const titleElement = this.querySelector('.radio__buttons--custom-title');
      if (titleElement) titleElement.textContent = event.target.value;
      const shipping = document.querySelector('[data-bw-free-shipping]');
      if (shipping && event.target) {
        shipping.hidden = event.target.getAttribute('data-free-shipping') !== 'true';
      }
      const bar = this.querySelector('.bw-bundle-bar');
      if (!bar) return;
      const inputs = Array.from(this.querySelectorAll('.radio__input'));
      const idx = inputs.findIndex((input) => input.checked);
      if (idx < 0) return;
      bar.setAttribute('data-quantity', String(idx + 1));
      bar.querySelectorAll('.bw-bundle-bar__item').forEach((item, index) => {
        item.setAttribute('aria-current', index === idx ? 'true' : 'false');
      });
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.handleVariantChange.bind(this));
    }
  }

  customElements.define('custom-variant-selector', CustomVariantSelector);
})();

(function () {
  function initAccordions(root = document) {
    root.querySelectorAll('details').forEach((d) => {
      if (d.__bound) return;
      d.__bound = true;
      const panel = d.querySelector(':scope > *:not(summary)');
      if (!panel) return;
      panel.style.overflow = 'hidden';
      panel.style.transition = 'max-height 0.3s ease';
      if (!d.open) panel.style.maxHeight = null;
      d.addEventListener('toggle', () => {
        panel.style.maxHeight = d.open ? panel.scrollHeight + 'px' : null;
      });
    });

    root.querySelectorAll('.accordion,[data-accordion]').forEach((btn) => {
      if (btn.__bound) return;
      btn.__bound = true;
      const panel = btn.nextElementSibling;
      btn.setAttribute('role', 'button');
      btn.setAttribute('aria-expanded', btn.getAttribute('aria-expanded') || 'false');
      if (panel) {
        panel.style.overflow = 'hidden';
        panel.style.transition = 'max-height 0.3s ease';
        if (btn.getAttribute('aria-expanded') !== 'true') panel.style.maxHeight = null;
      }
      btn.addEventListener('click', () => {
        const open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        if (panel) panel.style.maxHeight = open ? null : panel.scrollHeight + 'px';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAccordions());
  } else {
    initAccordions();
  }

  document.addEventListener('shopify:section:load', (e) => initAccordions(e.target));
  document.addEventListener('shopify:section:select', (e) => initAccordions(e.target));
})();
